import axios from "axios";
const apiInstance = axios.create({
  // baseURL: "https://fra.thegrapestudio.com/api",
  //baseURL: "https://api.fra-wizardevacplan.co.uk/api",
  baseURL: "https://project.frawizard.co.uk/lv/public/api",
});

export const updateFloorPlan = async (floor, floorId, token) => {
  let data =  {};
  let floorPlanArray = floor.floorplan;
  data.floorplan = floorPlanArray;
  //return true;
  data.token = token;
  
  if(floorId){
    return apiInstance.put(`/floorplan/${floorId}`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  }else{
    return apiInstance.post(`/floorplan`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  }
  
};
export const getFloorPlan = async (floorId, token) => {
  if (!floorId) {
    return false;
  }
  const url = `/floorplan/${floorId}?token=${token}`;

  return apiInstance.get(url, {
    headers: { Authorization: "Bearer " + token },
  });
};

/* 
export const getFloorPlan = async (floorId, token) => {
  if(!floorId){
    return false;
  }
  return apiInstance.get(`/floorplan/${floorId}`, {
    headers: { Authorization: "Bearer " + token },
  });
}; */

